export const OPEN_CRITERIA_WHO_EVENT = 'openCriteriaWho';
